import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export function BountySuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState({ loading: true, paid: false });

  useEffect(() => {
    const session_id = params.get("session_id");
    if (!session_id) { setState({ loading: false, paid: false, error: "Missing session id" }); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/bounties/status/${session_id}`);
        if (data.payment_status === "paid") { setState({ loading: false, paid: true }); return; }
        if (tries++ < 12) setTimeout(poll, 2000);
        else setState({ loading: false, paid: false, error: "Payment not confirmed" });
      } catch (err) {
        if (tries++ < 12) setTimeout(poll, 2000);
        else setState({ loading: false, paid: false, error: err?.response?.data?.detail || "Failed" });
      }
    };
    poll();
  }, [params]);

  return (
    <div className="mx-auto max-w-md px-6 py-24 text-center">
      {state.loading ? (
        <>
          <Loader2 className="mx-auto h-10 w-10 text-primary animate-spin" />
          <div className="mt-6 text-lg font-bold">Confirming your bounty escrow…</div>
          <div className="mt-2 text-sm text-muted-foreground">Stripe is verifying the payment.</div>
        </>
      ) : state.paid ? (
        <>
          <CheckCircle2 className="mx-auto h-12 w-12 text-primary" />
          <div className="mt-6 text-3xl font-black tracking-tighter">Bounty funded.</div>
          <div className="mt-2 text-sm text-muted-foreground">The bounty is now held in escrow and will be released to the responder you accept.</div>
          <Link to="/companies/portal"><button data-testid="bounty-back" className="mt-6 border border-primary bg-primary/10 text-primary px-4 py-2 uppercase tracking-widest text-xs hover:bg-primary/20">← Back to portal</button></Link>
        </>
      ) : (
        <>
          <XCircle className="mx-auto h-12 w-12 text-destructive" />
          <div className="mt-6 text-2xl font-black tracking-tighter">Not confirmed</div>
          <div className="mt-2 text-sm text-muted-foreground">{state.error || "Stripe didn't confirm the payment in time. Try again from the portal."}</div>
          <button data-testid="bounty-retry" onClick={() => nav("/companies/portal")} className="mt-6 border border-border px-4 py-2 uppercase tracking-widest text-xs hover:border-primary">Return to portal</button>
        </>
      )}
    </div>
  );
}
